module.exports = __webpack_public_path__ + "img/solution_3.b3c8d1ed.png";